module.exports = __webpack_public_path__ + "img/logo_1880_black.9a9e443.png";